import { platformSlaIdToServiceLevelName } from '@provision/service-level-utils';
import dayjs from 'dayjs';
import { ReactNode } from 'react';
import { DATE_FORMAT } from 'src/constants/date';
import {
  ActivityFeed,
  ActivityFeedChange,
} from 'src/graphql/entities/activity-feed/hooks/use-activity-feed';

export function getCustomAddressFieldMessage(
  change: ActivityFeedChange,
  activity: ActivityFeed,
): ReactNode {
  const actorName = activity.actor?.name?.trim() || '<Platform User>';

  switch (change.field) {
    case 'tosAccepted':
      return change.value?.toLowerCase() === 'yes'
        ? 'The terms of Service was accepted.'
        : 'The terms of Service was changed to not accepted.';
    case 'orgNotes':
      return `${actorName} updated the site notes.`;
    case 'membershipSalesNotes':
      return `${actorName} updated the membership notes.`;
    case 'cppExpDate': {
      const cppExpiration = activity.changes.find((change) => change.field === 'cppExpDate');
      const platformSlaIdChange = activity.changes.find(
        (change) => change.field === 'platformSlaId',
      );

      const serviceLevelValue = platformSlaIdToServiceLevelName(platformSlaIdChange?.value);
      const serviceLevelPreviousValue = platformSlaIdToServiceLevelName(
        platformSlaIdChange?.previousValue,
      );

      if (!cppExpiration) {
        return null;
      }
      const cppExpDate = dayjs(cppExpiration.value);
      if (cppExpDate.isSame(dayjs(), 'date') && !!serviceLevelValue) {
        return `Complimentary Membership Expired. Service Level changed to ${serviceLevelValue}`;
      } else if (serviceLevelValue !== serviceLevelPreviousValue) {
        return (
          <>
            {actorName} changed Service Level from <b>{serviceLevelPreviousValue}</b> to{' '}
            <b>{serviceLevelValue}</b> ({'expires '}
            {cppExpDate.format(DATE_FORMAT)})
          </>
        );
      }
      return `${actorName} updated the complimentary membership to expire on ${cppExpDate.format(DATE_FORMAT)}`;
    }
    case 'deletedAt': {
      const isRestored = change.previousValue !== null && change.value === null;
      if (isRestored) {
        return `${actorName} restored the site`;
      }
      return null;
    }
    default:
      return null;
  }
}
